import React from 'react';

const SuccessModal = ({ show, onClose }) => {
  if (!show) return null;
  return (
    <div id="success-modal" className="success-modal" style={{ display: 'block' }}>
      <div className="modal-content">
        <div className="modal-header">
          <i className="fas fa-check-circle"></i>
          <h3>Thank You!</h3>
        </div>
        <div className="modal-body">
          <p>Your message has been sent successfully. We will get back to you soon.</p>
        </div>
        <button className="modal-close" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default SuccessModal;
